<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="创建日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择创建日期" v-decorator="['createTime']" :trigger-change="true" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择开始时间" v-decorator="['startTime']" :trigger-change="true" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="维修地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bxAddress']" placeholder="请输入维修地点"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="维修人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bxZhuanyuan']" placeholder="请输入维修人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="维修时长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['times']" placeholder="请输入维修时长"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="满意度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['manyidu']" placeholder="请输入满意度"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="所用材料" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['skuName']" placeholder="请输入所用材料"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="所用材料费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['price']" placeholder="请输入所用材料费用"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="打车费" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['carAmout']" placeholder="请输入打车费"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="其他费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ortherAmout']" placeholder="请输入其他费用"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'FeiyongtjForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/feiyongtj/add",
          edit: "/feiyongtj/edit",
          queryById: "/feiyongtj/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'createTime','startTime','bxAddress','bxZhuanyuan','times','manyidu','skuName','price','carAmout','ortherAmout'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'createTime','startTime','bxAddress','bxZhuanyuan','times','manyidu','skuName','price','carAmout','ortherAmout'))
      },
    }
  }
</script>